export default __webpack_public_path__ + "static/media/pg-29.1a7c19be.jpg";